import React from 'react';

const Certification = () => {
  return (
    <div className=" bg-[#f5f5f0] p-6 text-gray-800">
      <div className="max-w-5xl mx-auto  ">
       <h1 className="text-3xl md:text-4xl font-bold text-center text-[#333333] mb-10 border-b-2 pb-2 border-[#b7b7a1]">Certified Copies of Revenue Documents</h1>
       <p className="text-md text-justify text-[#444] mb-8">Our dedicated team is committed to assisting customers in obtaining certified copies of revenue documents for both agricultural and non-agricultural properties from key government authorities, including the Tahsildar, the Survey Department, and the offices of the Assistant Commissioner (AC) and Deputy Commissioner (DC). With the guidance of our expert lawyers, our experienced staff expertly navigates the intricacies of these administrative processes, ensuring that all applications are meticulously completed and submitted in accordance with local regulations. By providing comprehensive support—including document preparation, application tracking, and liaising with relevant officials—we streamline the path to acquiring essential property records. Our goal is to empower clients with the necessary legal documentation for their real estate needs, fostering a hassle-free experience while ensuring compliance and clarity in property ownership.</p>
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Available Documents:</h2>
          <ul className="list-disc list-inside space-y-1 font-medium">
            <li>IL & RR</li>
            <li>Old RTC</li>
            <li>Mutation Registrar</li>
            <li>No Tenancy Endorsement</li>
            <li>79 A & B Endorsement</li>
            <li>RRT Orders</li>
            <li>AC & DC Court Orders</li>
            <li>Conversion Copies</li>
          </ul>
        </div>

        <div className="space-y-6 text-justify leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold mb-2">Introduction</h2>
            <p>
              In real estate transactions and property ownership, the importance of having certified copies of all registered documents cannot be overstated. Ensuring these documents are accurate and legally binding is fundamental for property owners, buyers, and stakeholders.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Legal Significance of Registered Documents</h2>
            <ul className="list-disc list-inside ml-4">
              <li><strong>Proof of Ownership:</strong> Certified copies confirm ownership and help protect against disputes.</li>
              <li><strong>Public Record:</strong> Registration ensures transparency for banks, buyers, and legal verification.</li>
              <li><strong>Protection Against Fraud:</strong> Ensures all property transactions are officially recorded.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Importance in Real Estate Transactions</h2>
            <ul className="list-disc list-inside ml-4">
              <li><strong>Due Diligence:</strong> Buyers can validate ownership and check for legal issues.</li>
              <li><strong>Loan Facilitation:</strong> Banks require these documents for processing property loans.</li>
              <li><strong>Easements and Rights of Way:</strong> Helps avoid disputes and confirms land-use rights.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Necessity in Legal Proceedings</h2>
            <ul className="list-disc list-inside ml-4">
              <li><strong>Evidence in Court:</strong> Certified documents are admissible proof of ownership.</li>
              <li><strong>Compliance:</strong> Essential for processes like succession claims or partition suits.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Administrative and Governmental Requirements</h2>
            <ul className="list-disc list-inside ml-4">
              <li><strong>Property Tax Assessments:</strong> Local authorities verify property size and value.</li>
              <li><strong>Transfers and Succession:</strong> Ensures smooth property transfer and legal compliance.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Conclusion</h2>
            <p>
              Certified copies are crucial for proving ownership, processing loans, avoiding legal issues, and maintaining real estate transparency. Property owners and buyers should always ensure access to these legal documents.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Recommendations</h2>
            <ul className="list-disc list-inside ml-4">
              <li>Always obtain certified copies from the registering authority after transactions.</li>
              <li>Our team can help acquire these documents for you.</li>
              <li>Our legal counsel provides support to safeguard and manage all property documentation.</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Certification;
